import { observable, action } from "mobx";
import {httpClient} from "../utils/httpClient";
import Cookies from "js-cookie";
import api from "../config/api"
const {common}=api

class CommonStore {
  @action
  updateState(params = {}) {
    Object.entries(params).forEach(([key, val]) => {
      this[key] = val;
    })
  }

  @observable isFullScreen = false;
  @observable routeBarFlag = 1; // routeBar触发更新标记
  @observable routeBarHasBack = false; // routeBar 返回按钮

  @action
  setRouteBarList(routeItem = {}) {
    const routeBarList = JSON.parse(sessionStorage.getItem('route_bar_list')) || [];
    const currItem = routeBarList.find(item => item.route === routeItem.route);
    if (!currItem || currItem.search !== routeItem.search) {
      routeBarList.push(routeItem);
      sessionStorage.setItem('route_bar_list', JSON.stringify(routeBarList.slice(-10)));
      
      this.routeBarFlag = this.routeBarFlag + 1;
    }
  }

  // 顶部菜单选中状态

  @observable topMenu = "connect";
  @observable checkAccountData = {telephone:''};


  /**
   * 登陆
   * @param params
   * @returns {Promise<AxiosResponse<T>>}
   */
  @action
  async login(params) {
    const data = await httpClient.post(common.POST_LOGIN, {...params});
    if (data.success) {
      localStorage.setItem('userInfo', JSON.stringify(data.data));
      localStorage.setItem("token", data.data.authorityToken);
      Cookies.set('token', data.data.authorityToken);
    }
    return data
  }

  @action
  async updatePwdByOldPwd(params) {
    const data = await httpClient.post(common.updatePwdByOldPwd, {...params});
    return data
  }



  // 登出
  @action
  async logout(params) {
    const data = await httpClient.post(common.GET_LOGOUT, {...params});
    if (data.success) {
      localStorage.removeItem("token");
      localStorage.removeItem('userInfo');
    }
    return data
  }

  /**
   * 忘记密码第一步
   * @param params
   * @returns {Promise<AxiosResponse<T>>}
   */
  @action
  async postCheckAccount(params) {
    const data = await httpClient.post(common.CHECK_ACCOUNT, {...params})
    if (data.success) {
      this.checkAccountData = data.data
      localStorage.setItem("forgetPwd",JSON.stringify(data.data))
    }
    return data
  }

  /**
   * 忘记密码第二步
   * @param params
   * @returns {Promise<AxiosResponse<T>>}
   */
  @action
  async postSetNewPassword(params){
    const data=await httpClient.post(common.SET_NEW_PASSWORD,{...params});
    if(data.success){

    }
    return data
  }
  

  // 当前顶部选中的按钮的index
  @action
  setMenuKey = async key => {
    this.topMenu = key;
  };


  // 上传单个文件
  @action async uploadSingleFile(params) {
    let { data } = await httpClient.post(common.UPLOAD_SINGLE_FILE, params, {
      withCredentials:true,
      headers: {
        'Content-Type': 'multipart/form-data',
        'Accept': '*/*'
      },
    })
    return data
  }
  // 上传多个文件
  @action async uploadMultipleFile(params) {
    let { data } = await httpClient.post(common.UPLOAD_MULTIPLE_FILE, params, {
      withCredentials:true,
      headers: {
        'Content-Type': 'multipart/form-data',
        'Accept': '*/*'
      },
    })
    return data
  }
  
  // 上传单个文件-新
  @action async uploadSingleFileNew(params) {
    try {
      const { data } = await httpClient.post(common.UPLOAD_SINGLE_FILE_NEW, params, {
        withCredentials:true,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept': '*/*'
        },
      })
      
      return data
    } catch (error) {
      return {}
    }
  }

  // 发送短信验证码
  @action async sendSmsCode(params) {
    try {
      const { success } = await httpClient.post(common.SEND_SMS_CODE, params);
      return success
    } catch (error) {
      return false
    }
  }

  // 忘记密码发送短信验证码
  @action async pwdSendSmsCode(params) {
    try {
      const { success } = await httpClient.post(common.PWD_SEND_SMS_CODE, params);
      return success
    } catch (error) {
      return false
    }
  }
}

export default new CommonStore();
